<template>
  <div>
    <div
      v-if="ownerId && ehTabela == null"
      class="flex items-center my-2"
      slot="trigger"
      aria-controls="crm-aria"
    >
      <Icon-Id class="text-primary-600" size="8" />
      <p class="pl-4 font-display font-bold text-xl">
        {{ ownerType == "empresa" ? "CRM PJ" : "CRM PF" }}
      </p>
    </div>

    <v-dialog v-model="showCrmModal">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          v-if="ehTabela == null"
          @click.native="openCrmModal"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
        >
          {{ ownerId ? "Gerenciar CRM" : "Criar CRM" }}
        </v-btn>

        <v-btn
          v-else
          @click.native="openCrmModal"
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          fab
          small
        >
          <v-icon>mdi-pencil</v-icon>
        </v-btn>
      </template>

      <v-card class="p-2" :loading="loading" min-height="500">
        <v-card-title class="headline row justify-between"
          >Gerenciamento de CRM
          <Lynx-Button
            v-if="crms.length !== 0"
            text="Cadastrar"
            size="small"
            icon="Plus"
            @click.native="onCreate"
        /></v-card-title>

        <v-card-text
          class="mt-5"
          v-if="permanecerEscolherPayer && showCrmModal"
        >
          <EscolherPayer @payerEscolhido="payerEscolhido" />
        </v-card-text>
        <v-card-text v-if="ownerId != null">
          <v-row>
            <v-col
              col="12"
              :md="crms.length <= 3 ? 4 : 3"
              v-for="(crm, index) in crms"
              :key="index"
            >
              <v-card
                :style="
                  crmId == crm.id ? 'border-color:green; border-width:3px;' : ''
                "
                class="p-3"
                shaped
                :loading="loading && isEditting.index == index"
              >
                <div
                  class="w-full flex justify-center py-4"
                  v-if="loading && isEditting.index == index"
                >
                  <Lynx-Spinner size="16" />
                </div>
                <div v-else>
                  <v-select
                    v-if="isEditting.index == index"
                    v-model="crm.status"
                    item-text="label"
                    item-value="id"
                    :items="[
                      { label: 'Já Emitido', id: 1 },
                      { label: 'Previsão', id: 5 },
                      { label: 'Solicitação', id: 6 },
                    ]"
                    label="Selecione uma opção"
                    @change="checkChanges(index, crm.status)"
                  ></v-select>
                  <form class="flex flex-col" @submit.prevent="submitMethod">
                    <!-- Emissão / Previsão -->
                    <div class="flex items-center py-1">
                      <p class="flex items-center">
                        <span class="pr-2 text-neutral-700 font-bold">
                          {{
                            crm.status == 1
                              ? "Emissão"
                              : crm.status == 6
                              ? "Solicitação"
                              : "Previsão"
                          }}
                        </span>
                        <transition name="fade" mode="out-in">
                          <span
                            class="text-neutral-700 truncate"
                            v-if="isEditting.index != index"
                          >
                            {{ handledDataEmissao(crm.data_emissao) }}
                            <CopyText
                              :valor="handledDataEmissao(crm.data_emissao)"
                            />
                          </span>
                          <input-date
                            v-model="$v.form.data_emissao.$model"
                            :error="$v.form.data_emissao.$error"
                            v-else
                          />
                        </transition>
                      </p>
                    </div>

                    <!-- Número -->
                    <div class="flex items-center py-1" v-if="hasCrm[index]">
                      <div class="flex items-center">
                        <span class="pr-2 text-neutral-700 font-bold"
                          >Número:</span
                        >
                        <transition name="fade" mode="out-in">
                          <span
                            class="text-neutral-700"
                            v-if="isEditting.index != index && !crm.senha"
                            >-</span
                          >
                          <div v-else-if="isEditting.index != index">
                            <span class="text-neutral-700 truncate"
                              >{{ crm.numero }}
                            </span>

                            <CopyText :valor="crm.numero" />
                          </div>
                          <Lynx-Input
                            v-model="$v.form.numero.$model"
                            :error="$v.form.numero.$error"
                            v-else
                          />
                        </transition>
                      </div>
                    </div>

                    <!-- Senha -->
                    <div class="flex items-center py-1" v-if="hasCrm[index]">
                      <div class="flex items-center">
                        <span class="pr-2 text-neutral-700 font-bold"
                          >Senha:</span
                        >
                        <transition name="fade" mode="out-in">
                          <span
                            class="text-neutral-700"
                            v-if="isEditting.index != index && !crm.senha"
                            >-</span
                          >
                          <div v-else-if="isEditting.index != index">
                            <span class="text-neutral-700">{{
                              crm.senha
                            }}</span>

                            <CopyText :valor="crm.senha" />
                          </div>
                          <Lynx-Input
                            v-model="$v.form.senha.$model"
                            :error="$v.form.senha.$error"
                            v-else
                          />
                        </transition>
                      </div>
                    </div>

                    <!-- Link -->
                    <div class="flex items-center py-1" v-if="hasCrm[index]">
                      <p class="flex items-center">
                        <span class="pr-2 text-neutral-700 font-bold"
                          >Link:</span
                        >
                        <transition name="fade" mode="out-in">
                          <span
                            class="text-neutral-700"
                            v-if="isEditting.index != index && !crm.link"
                            >-</span
                          >
                          <div v-else-if="isEditting.index != index">
                            <span class="text-neutral-700">{{ crm.link }}</span>
                            <CopyText :valor="crm.link" />
                          </div>
                          <Lynx-Input
                            v-model="$v.form.link.$model"
                            :error="$v.form.link.$error"
                            v-else
                          />
                        </transition>
                      </p>
                    </div>

                    <!-- Estado -->
                    <v-row v-if="hasCrm[index]">
                      <v-col cols="12" md="12" class="row align-center">
                        <Lynx-Label
                          class="text-neutral-700 font-bold col-6 col-md-2"
                          label="Estado:"
                          :validator="$v.form.estado_id"
                          :validations-message="
                            validationsMessage.form.estado_id
                          "
                        />
                        <div v-if="isEditting.index != index" class="mt-1 ml-2">
                          <div v-if="crm.estado">
                            <span class="text-neutral-700">{{
                              crm.estado.nome
                            }}</span>
                            <CopyText :valor="crm.estado.nome" />
                          </div>
                          <span class="ml-1" v-else>-</span>
                        </div>
                        <div v-else class="col-md-10">
                          <Treeselect
                            :options="lista_estados"
                            placeholder="Selecione o estado"
                            v-model="$v.form.estado_id.$model"
                          />
                        </div>
                      </v-col>
                    </v-row>

                    <div v-if="crm.status == 6 && ownerType != 'cliente'">
                      <v-select
                      :disabled="isEditting.index != index"
                        v-model="crm.tipo_solicitacao_id"
                        item-text="label"
                        item-value="id"
                        :items="[
                          { label: 'CRM Novo', id: 1 },
                          { label: 'Renovação', id: 2 },
                          { label: 'Alteração de Estado', id: 3 },
                          { label: 'Baixa de CRM', id: 4 },
                          { label: 'Taxa de Anuidade', id: 5 },
                        ]"
                        label="Selecione uma opção"
                      ></v-select>

                      <v-textarea
                      :disabled="isEditting.index != index"
                        v-model="crm.observacao"
                        label="Observação"
                        rows="5"
                        auto-grow
                        outlined
                        required
                      ></v-textarea>
                    </div>
                    <!-- Cidade 
                    <v-row v-if="hasCrm[index]">
                      <v-col cols="12" md="12" class="row align-center">
                        <Lynx-Label
                          class="text-neutral-700 font-bold col-6 col-md-2"
                          label="Cidade:"
                          :validator="$v.form.cidade_id"
                          :validations-message="
                            validationsMessage.form.cidade_id
                          "
                        />
                        <div v-if="isEditting.index != index" class="mt-1 ml-2">
                          <div v-if="crm.cidade">
                            <span class="text-neutral-700">{{
                              crm.cidade.nome
                            }}</span>
                            <CopyText :valor="crm.cidade.nome" />
                          </div>
                          <span class="ml-1" v-else>-</span>
                        </div>
                        <div v-else class="col-md-10">
                          <Treeselect
                            :options="lista_cidades"
                            placeholder="Selecione a cidade"
                            v-model="$v.form.cidade_id.$model"
                          />
                        </div>
                      </v-col>
                    </v-row>
                    -->
                    <v-row class="justify-between">
                      <Lynx-Button
                        v-if="isEditting.index == index"
                        class="my-4 self-start"
                        style="color: white"
                        text="Salvar"
                        icon="Save"
                        size="small"
                        icon-size="4"
                        type="submit"
                      />
                      <Lynx-Button
                        v-if="isEditting.index == index"
                        class="my-4 self-start"
                        style="color: white"
                        text="cancelar"
                        icon="Edit"
                        size="small"
                        icon-size="4"
                        @click.native="cancelar"
                        type="button"
                      />
                    </v-row>
                  </form>
                  <div v-if="isEditting.index != index">
                    <Lynx-Button
                      v-if="!estaUsandoEsseCrm"
                      class="my-4 self-start"
                      style="color: white"
                      text="Editar"
                      icon="Edit"
                      size="small"
                      icon-size="4"
                      @click.native="onEdit(index, crm)"
                      type="button"
                    />
                  </div>
                </div>
              </v-card>
            </v-col>
          </v-row>
          <div
            class="my-4 self-center flex flex-col items-center"
            v-if="!loading && crms.length === 0"
          >
            <NotFoundData text="CRM ainda não cadastrado" />
            <Lynx-Button
              text="Cadastrar"
              size="small"
              icon="Plus"
              @click.native="onCreate"
            />
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {
  crmsRequest,
  crmsCreateRequest,
  crmsUpdateRequest,
} from "@/services/requests/crms";
import { required } from "vuelidate/lib/validators";
import NotFoundData from "@/components/layouts/NotFoundData";
import formMixin from "@/mixins/form";
import moment from "moment";
import InputDate from "@/components/helpers/InputDate";
import CopyText from "@/components/shared/CopyText";
import Treeselect from "@riophae/vue-treeselect";
import {
  indexEstadosRequest,
  showEstadosRequest,
} from "@/services/requests/estados";
import EscolherPayer from "@/views/components/EscolherPayer";

export default {
  name: "Crm",
  components: { InputDate, CopyText, NotFoundData, Treeselect, EscolherPayer },
  mixins: [formMixin],
  props: {
    ownerTypeParametro: {
      validator: (value) => ["empresa", "cliente"].indexOf(value) !== -1,
      default: null,
    },
    ownerIdParametro: {
      type: Number,
      default: null,
    },
    permanecerEscolherPayer: {
      type: Boolean,
      default: null,
    },
    ehTabela: {
      type: Boolean,
      default: null,
    },
    crmId: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      ownerType: null,
      ownerId: null,
      showCrmModal: false,
      estaUsandoEsseCrm: false,
      hasCrm: [],
      crmDados: {},
      crms: [],
      cidades: [],
      estados: [],
      loading: false,
      isEditting: { index: null },
      formContante: {
        numero: "",
        senha: "",
        estado: "",
        data_emissao: "",
        link: null,
        cidade_id: null,
        estado_id: null,
        owner_type: null,
        owner_id: null,
        status: 5,
        observacao: null,
        tipo_solicitacao_id: null,
      },
      form: {},
      validationsMessage: {
        form: {
          numero: { required: "O campo número é obrigatório" },
          senha: { required: "O campo senha é obrigatório" },
          estado: { required: "O campo estado é obrigatório" },
          data_emissao: { required: "Informe a data de emissão" },
          cidade_id: { required: "Informe a cidade" },
          estado_id: { required: "Informe o estado" },
          observacao: { required: "Informe a  observação" },
          tipo_solicitacao_id: { required: "Informe o tipo de solicitação" },
        },
      },
    };
  },
  validations: {
    form: {
      numero: {},
      senha: {},
      estado: {},
      data_emissao: { required },
      link: {},
      estado_id: {},
      cidade_id: {},
    },
  },

  computed: {
    isOnlyPrevision() {
      return (
        // !this.hasCrm ||
        moment(this.crmDados.data_emissao).isAfter(new Date()) ||
        (this.crmDados.data_emissao && !this.crmDados.numero)
      );
    },
    lista_cidades() {
      return this.generateSelectOptions(this.cidades);
    },
    lista_estados() {
      return this.generateSelectOptions(this.estados);
    },
  },
  watch: {
    "form.estado_id": function () {
      if (this.form.estado_id) {
        this.onSelectEstado(this.form.estado_id);
      } else {
        this.cidades = [];
        this.form.cidade_id = null;
      }
    },
    showCrmModal() {
      this.crms = [];
      if (this.permanecerEscolherPayer) {
        this.ownerId = null;
        this.ownerType = null;
      }
    },
  },
  created() {
    this.fetchEstados();
    this.abrirCollapse();
  },
  methods: {
    openCrmModal() {
      this.showCrmModal = true;
      this.abrirCollapse();

      this.fetchCrm();
    },
    async fetchCrm() {
      this.loading = true;
      await crmsRequest(this.ownerType, this.ownerId)
        .then((res) => {
          this.crms = res.data;
          this.crms.forEach((crm, index) => {
            this.hasCrm[index] = !!crm.numero;
            if (crm.status == null) {
              crm.status = !!crm.numero ? 1 : 5;
            }
          });
        })
        .finally(() => (this.loading = false));
    },
    onCreate() {
      this.submitMethod = this.createCrm;
      this.crmDados = this.formContante;
      this.crms.push(this.formContante);
      this.form = this.formContante;
      const index = this.crms.length - 1;
      this.isEditting = { index: index };
      this.hasCrm[index] = false;
      this.estaUsandoEsseCrm = true;
    },
    onEdit(index, crm) {
      this.submitMethod = this.updateCrm;
      this.crmDados = crm;
      this.form = crm;
      this.isEditting = { index: index };
      this.estaUsandoEsseCrm = true;
    },
    cancelar() {
      this.form = this.formContante;
      if (!this.crmDados.id) {
        this.crms.splice(this.isEditting.index, 1);
      }
      this.crmDados = {};

      this.isEditting = { index: null };
      this.estaUsandoEsseCrm = false;
    },
    updateCrm() {
      if (this.$v.form.$invalid) return;
      this.loading = true;
      this.form.owner_id = this.ownerId;
      this.form.owner_type = this.ownerType;
      crmsUpdateRequest(this.crmDados.id, this.form)
        .then((res) => {
          this.$snack.success(res.data.msg);
          this.$emit("atualizou");
        })
        .catch((res) => {
          this.$snack.error(res.data.msg);
        })

        .finally(() => {
          this.showCrmModal = false;
          this.isEditting = { index: null };
          this.estaUsandoEsseCrm = false;
          this.loading = false;
        });
    },
    createCrm() {
      if (this.$v.form.$invalid) return;
      this.loading = true;
      this.form.owner_id = this.ownerId;
      this.form.owner_type = this.ownerType;
      crmsCreateRequest(this.form)
        .then((res) => {
          this.$snack.success(res.data.msg);
          this.$emit("atualizou");
        })
        .catch((res) => {
          this.$snack.error(res.data.msg);
        })

        .finally(() => {
          this.showCrmModal = false;
          this.isEditting = { index: null };
          this.estaUsandoEsseCrm = false;
          this.loading = false;
        });
    },
    async fetchEstados() {
      await indexEstadosRequest().then((res) => (this.estados = res.data));
    },
    async onSelectEstado(id) {
      this.loading = true;
      await showEstadosRequest(id)
        .then((res) => (this.cidades = res.data.cidades))
        .finally(() => (this.loading = false));
      if (this.form.estado_id != this.crmDados.estado_id) {
        this.form.cidade_id = null;
      }
      if (this.form.cidade_id) {
        this.form.cidade_id = this.cidades.find(
          (item) => item.id == this.crmDados.cidade_id
        ).id;
      }
    },
    checkChanges(index, status) {
      this.hasCrm[index] = status == 1;
      this.isEditting = { index: index };
    },
    generateSelectOptions(data) {
      let options = [];
      for (let i = 0; i < data.length; i++) {
        options.push({ id: data[i].id, label: data[i].nome });
      }
      return options;
    },
    handledDataEmissao(data_emissao) {
      if (!data_emissao) {
        return "Sem data :(";
      }

      let date = moment(data_emissao);

      if (this.isOnlyPrevision) {
        return date.format("DD/MM/YYYY") + " (previsão)";
      }

      return date.format("DD/MM/YYYY");
    },

    abrirCollapse() {
      if (this.ownerIdParametro != null) {
        this.ownerId = this.ownerIdParametro;
        this.ownerType = this.ownerTypeParametro;
      }
    },
    payerEscolhido(dados) {
      if (dados.payer_id != null) {
        this.ownerId = dados.payer_id;
        this.ownerType = dados.payer_type;
      }
    },
  },
};
</script>
